import { Button, Dropdown, message, Select, Space, Tooltip } from "antd";

function DropdownComponent({getValue,dataList,value,hasError}) {

  return (
    <Select

    onSelect={(value)=>{
      getValue(value)

    }}
    value={value}
    size="large"
    bordered={false}
    dropdownStyle={{marginLeft:'2rem'}}
    style={{ width: "100%",borderRadius:'10px',
    border:hasError?"2px solid red":"1.5px solid #d9d9d9",backgroundColor:'white',alignItems:'center',marginTop:'0.5rem',height:'45px'}}
    placeholder="Search to Select"
    optionFilterProp="children"
    
    filterOption={(input, option) => (option?.label ?? '').includes(input)}
    filterSort={(optionA, optionB) =>
      (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
    }
    options={dataList}
    // status={`${hasError?"error":""}`}
    
  />
  );
}

export default DropdownComponent;

DropdownComponent.defaultProps={
  hasError:false
}

